import _set from 'lodash/set'
import _get from 'lodash/get'
import _isEqual from 'lodash/isEqual'
import _map from 'lodash/map'
import _filter from 'lodash/filter'
import _isEmpty from 'lodash/isEmpty'
import _includes from 'lodash/includes'
import React from 'react'
import { withRouter } from 'react-router-dom'
import Modal from 'react-modal'
import { Field as FormikField, withFormik } from 'formik'

import modalStyle from '../../../_common/core/modalStyle'
import { extractContent } from '../../../_common/core/utils'
import { ENV } from '../../constants/env'
import Field from '../../_library/Field'
import Button from '../../_library/Button'
import RichTextArea from '../../_library/RichTextArea'
import LoadingBar from '../../_library/LoadingBar'
import SelectTimeSlots from '../../events/_library/SelectTimeSlots/'
import {
  // normalizers
  formatDay,
  formatTime,
  isEmailValidator,
} from '../../../_common/core/validation'

import { CheckboxField, MultiCheckbox } from '../../formik/Fields'
import ScheduleEmail from '../../_features/scheduleEmail'
import CustomTooltip from '../../_library/CustomTooltip'
import TagsField from '../../_library/TagsField'
import { ROLES } from '../../constants/roles'

const getDayAndHour = date => {
  const d = formatDay(date)
  const h = formatTime(date)
  return [d, h]
}
function validateForm(data) {
  const errors = {}
  if (!_get(data, 'subject')) {
    _set(errors, 'subject', 'Required')
  }
  const extract_content = extractContent(_get(data, 'body'))
  const pure_body = extract_content === '+' ? '' : extract_content
  if (!pure_body) {
    _set(errors, 'body', 'Body is Required')
  }

  if (_get(data, 'toTestEmailFlag')) {
    if (!_get(data, 'toTestEmail')) {
      _set(errors, 'toTestEmail', 'Required')
    } else if (isEmailValidator()(_get(data, 'toTestEmail'))) {
      _set(errors, 'toTestEmail', 'Invalid email')
    }
  }

  if (_get(data, 'toSpecificEmailHolders')) {
    const specificEmailAddresses = _get(data, 'specificEmailAddresses') || []
    if (specificEmailAddresses.length === 0) {
      _set(errors, 'specificEmailAddresses', 'At least one email is required')
    } else {
      const re = global.emailRegex
      for (const em of specificEmailAddresses) {
        if (!re || !re.test(em)) {
          _set(errors, 'specificEmailAddresses', 'Invalid email')
          break
        }
      }
    }
  }

  return errors
}

@withRouter
class EmailToTicketHolders extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      toSelectedAddonHolders: false,
      addOnsStateInitialized: false,
      toTicketHolders: false,
      emailTemplatesModalOpen: false,
      isConfirmingModalOpen: false,
      addOnsWereFetched: false,
      ticketsWereFetched: false,
      checkedAddOnsArray: [],
      selectedNoGroupedTickets: [],
    }
    this.editorRef = React.createRef()
  }

  componentDidMount() {
    const { values, event } = this.props

    if (values.subject === null || values.subject === '') {
      setTimeout(() => {
        this.props.setFieldValue('subject', 'Message to attendees of ' + event.displayName)
      }, 0)
    }
  }

  componentWillUpdate(nextProps) {
    if (
      !_isEqual(this.props.values, nextProps.values) &&
      !_isEqual(this.props.submitCount, nextProps.submitCount)
    ) {
      this.setState({
        toTicketHolders: !!nextProps.values.toSelected,
        toSelectedAddonHolders: !!nextProps.values.toSelectedAddonHolders,
        selectedNoGroupedTickets: [],
      })
    }
  }

  onCheckboxChange = domEvent => {
    const isChecked = domEvent.target.checked
    if (isChecked) {
      const targetCheckboxId = domEvent.target.id
      const { setFieldValue, eventAddOns } = this.props
      const addOnsArray = _map(eventAddOns, item => item.id)
      setFieldValue('toAll', targetCheckboxId === 'toAllTicketHolders')
      setFieldValue('toCheckedInCustomersOnly', targetCheckboxId === 'toCheckedInCustomersOnly')
      setFieldValue('toWaitingList', targetCheckboxId === 'toWaitingList')
      setFieldValue('toWaitingListWithoutOrders', targetCheckboxId === 'toWaitingListWithoutOrders')
      setFieldValue('toBrandSubscribers', targetCheckboxId === 'toBrandSubscribers')
      setFieldValue('toPreregisteredUsers', targetCheckboxId === 'toPreregisteredUsers')
      setFieldValue(
        'toPreregisteredUsersWithoutOrders',
        targetCheckboxId === 'toPreregisteredUsersWithoutOrders',
      )
      setFieldValue('toFrozenOrders', targetCheckboxId === 'toFrozenOrders')
      setFieldValue('toRefundedTicketHolders', targetCheckboxId === 'toRefundedTicketHolders')
      setFieldValue('toAllEventTeamMembers', targetCheckboxId === 'toAllEventTeamMembers')
      setFieldValue('toInfluencers', targetCheckboxId === 'toInfluencers')
      setFieldValue('toTestEmailFlag', targetCheckboxId === 'toTestEmailFlag')
      setFieldValue('toSpecificEmailHolders', targetCheckboxId === 'toSpecificEmailHolders')

      setFieldValue('toSelected', '')

      setFieldValue(
        'toSelectedAddonHolders',
        targetCheckboxId === 'toSelectedAddonHolders' ? addOnsArray : [],
      )
      this.setState({
        toSelectedAddonHolders: targetCheckboxId === 'toSelectedAddonHolders',
        toTicketHolders: targetCheckboxId === 'toTicketHolders',
      })
      // before initaliazitation eventAddOns prop will not be available
      if (this.state.addOnsStateInitialized) {
        this.setState({
          checkedAddOnsArray: addOnsArray,
        })
      }
      this.fetchCheckboxRelatedData(targetCheckboxId)
    }
  }

  fetchCheckboxRelatedData = fieldName => {
    const { fetchEventAddOns, fetchEventTickets } = this.props
    switch (fieldName) {
      case 'toTicketHolders': {
        if (!this.state.ticketsWereFetched) {
          fetchEventTickets()
          this.setState({ ticketsWereFetched: true })
        }
        return
      }
      case 'toSelectedAddonHolders': {
        if (!this.state.addOnsWereFetched) {
          fetchEventAddOns()
          this.setState({ addOnsWereFetched: true })
        }
        return
      }
      default:
        return
    }
  }

  initializeAddOnsState = () => {
    const addOnIdsArray = _map(this.props.eventAddOns, item => item.id)
    this.setState({ checkedAddOnsArray: addOnIdsArray })
    this.props.setFieldValue('toSelectedAddonHolders', addOnIdsArray)
  }

  onAddOnSelect = addOnId => () => {
    const { checkedAddOnsArray } = this.state
    const addOnIdIndex = checkedAddOnsArray.indexOf(addOnId)
    if (addOnIdIndex !== -1) {
      checkedAddOnsArray.splice(addOnIdIndex, 1)
    } else {
      checkedAddOnsArray.push(addOnId)
    }
    this.setState({ checkedAddOnsArray })
    this.props.setFieldValue('toSelectedAddonHolders', checkedAddOnsArray)
  }

  setEmailTemplatesModalState = value => () => {
    this.setState({
      emailTemplatesModalOpen: value,
    })
  }

  selectEmailTemplate = template => {
    this.props.setFieldValue('subject', template.subject)
    if (template.body) {
      this.editorRef.current?.setContent(template.body)
    } else if (template.preview_url) {
      $.get(template.preview_url, result => {
        this.editorRef.current?.setContent(result)
      })
    }
    this.setState({
      emailTemplatesModalOpen: false,
    })
  }

  onBodyChange = content => this.props.setFieldValue('body', content)

  onSpecificEmailsChange = tags => {
    this.props.setFieldValue('specificEmailAddresses', tags)
  }

  setConfirmingModalState = value => () => {
    this.setState({ isConfirmingModalOpen: value })
  }

  handleSubmit = () => {
    this.setConfirmingModalState(false)()
    this.props.handleSubmit()
  }

  componentDidUpdate() {
    if (
      !this.state.addOnsStateInitialized &&
      Object.keys(this.props.eventAddOns).length &&
      this.state.toSelectedAddonHolders
    ) {
      this.setState({ addOnsStateInitialized: true })
      this.initializeAddOnsState()
    }
  }

  isSendButtonDisabled = addOnsList => {
    const { values, eventTickets } = this.props
    return (
      (this.state.toTicketHolders && (!values.toSelected.length || !eventTickets.length)) ||
      (this.state.toSelectedAddonHolders && (!values.toSelectedAddonHolders.length || !addOnsList.length)) ||
      !_isEmpty(validateForm(values)) ||
      !values.marketingDisclaimer
    )
  }

  getOnlyTimeSlotTickets = () => {
    const { eventTickets } = this.props
    try {
      const filteredData = _filter(eventTickets, item => {
        const [d, h] = getDayAndHour(item.startDate)
        item.time = h
        item.date = d
        return item.slotGroupId ? true : false
      })
      return filteredData
    } catch (error) {
      return []
    }
  }

  handleScheduleConfirm = async scheduleDate => {
    const { handleSheduleMessage = () => {}, setFieldValue, resetForm, values = {}, event } = this.props

    try {
      const subject = `Message to attendees of ${event.displayName}`
      const withSheduleDateValues = { ...values, schedule_date: scheduleDate }

      await handleSheduleMessage(withSheduleDateValues)

      resetForm()
      setFieldValue('subject', subject)
    } catch (error) {}
  }

  render() {
    const { emailTemplatesModalOpen, isConfirmingModalOpen, toSelectedAddonHolders, toTicketHolders } =
      this.state
    const {
      event,
      values,
      eventTickets,
      isSubmitting,
      handleChange,
      handleBlur,
      errors,
      touched,
      submitLabel,
      eventAddOns,
      eventAddOnsLoading,
      eventTicketsLoading,
      history: { replace },
      configs,
      user,
    } = this.props
    let { emailTemplates = [] } = this.props
    const hideRSVPText = _get(configs, 'appearance.hideRSVPText', false)
    const hideAllPreregisteredCustomers = _get(configs, 'appearance.hideAllPreregisteredCustomers', false)
    const hideHoldersOfRefundedTickets = _get(configs, 'appearance.hideHoldersOfRefundedTickets', false)
    // const hideHoldersOfSlidingScaleTickets = _get(
    //   configs,
    //   'appearance.hideHoldersOfSlidingScaleTickets',
    //   false,
    // )
    const hideHoldersOfSpecificAddOns = _get(configs, 'appearance.hideHoldersOfSpecificAddOns', false)
    const isTfUser = _includes(_get(user, 'email'), 'ticketfairy')
    const userTfRole = _get(user, 'tfRole')
    const isTtfStaff = ROLES.is_ttf_staff(userTfRole)

    if (emailTemplates.length) {
      emailTemplates = emailTemplates.filter(el => el.type === 'messaging' && el.enabled === 1)
    }

    const [noGroupedTickets, groupedTickets] = ticketTypesSorting(eventTickets)

    const addOnsList = _map(eventAddOns, (addOn, index) => (
      <div key={index} className="line addon">
        <div className="line-cell">
          <input
            type="checkbox"
            id={`addon-${addOn.id}`}
            defaultChecked={true}
            name={addOn.id}
            onChange={this.onAddOnSelect(addOn.id)}
          />
          <label htmlFor={`addon-${addOn.id}`} />
        </div>
        <div className="line-cell" style={{ paddingLeft: 0 }}>
          <label htmlFor={`addon-${addOn.id}`}>{addOn.name}</label>
        </div>
      </div>
    ))

    return (
      <form ref="form" onSubmit={e => e.preventDefault()}>
        <div className="EmailToTicketHolders">
          <div className="row">
            <div className="col-xs-12 text-right">
              <div
                aria-hidden
                className="btn btn-success btn-shadow"
                onClick={this.setEmailTemplatesModalState(true)}
              >
                Select from Email Templates
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <Field
                id="subject"
                label="Subject"
                value={values.subject}
                error={errors.subject}
                touched={touched.subject}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>

          <div className="row" style={{ marginBottom: 10 }}>
            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toAllTicketHolders"
                checked={values.toAll}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toAllTicketHolders">{`All ticket holders${
                hideRSVPText ? '' : ' and RSVPs'
              }`}</label>
            </div>

            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toCheckedInCustomersOnly"
                checked={values.toCheckedInCustomersOnly}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toCheckedInCustomersOnly">Checked in customers only</label>
            </div>

            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toWaitingList"
                checked={values.toWaitingList}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toWaitingList">All waiting list members</label>
            </div>
            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toWaitingListWithoutOrders"
                checked={values.toWaitingListWithoutOrders}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toWaitingListWithoutOrders">All waiting list members without orders</label>
            </div>
            {hideAllPreregisteredCustomers ? null : (
              <div className="col-xs-4 col-12 padding-bottom10">
                <input
                  style={{ marginRight: 10 }}
                  type="checkbox"
                  id="toPreregisteredUsers"
                  checked={values.toPreregisteredUsers}
                  onChange={this.onCheckboxChange}
                />
                <label htmlFor="toPreregisteredUsers">All pre-registered customers</label>
              </div>
            )}
            {hideAllPreregisteredCustomers ? null : (
              <div className="col-xs-4 col-12 padding-bottom10">
                <input
                  style={{ marginRight: 10 }}
                  type="checkbox"
                  id="toPreregisteredUsersWithoutOrders"
                  checked={values.toPreregisteredUsersWithoutOrders}
                  onChange={this.onCheckboxChange}
                />
                <label htmlFor="toPreregisteredUsersWithoutOrders">
                  All pre-registered customers without orders
                </label>
              </div>
            )}
            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toBrandSubscribers"
                checked={values.toBrandSubscribers}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toBrandSubscribers">All event opted-in ticket holders</label>
            </div>
            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toAllEventTeamMembers"
                checked={values.toAllEventTeamMembers}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toAllEventTeamMembers">All event team members</label>
            </div>
            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toTicketHolders"
                checked={toTicketHolders}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toTicketHolders">Holders of specific tickets</label>
              <br />
            </div>
            {
              //TODO: add back when the issue is fixed
              /*hideHoldersOfSlidingScaleTickets ? null : (
              <div className="col-xs-4 col-12 padding-bottom10">
                <input
                  style={{ marginRight: 10 }}
                  type="checkbox"
                  id="toFrozenOrders"
                  checked={values.toFrozenOrders}
                  onChange={this.onCheckboxChange}
                />
                <label htmlFor="toFrozenOrders">Holders of sliding scale tickets</label>
              </div>
            )*/
            }
            {hideHoldersOfSpecificAddOns ? null : (
              <div className="col-xs-4 col-12 padding-bottom10">
                <input
                  style={{ marginRight: 10 }}
                  type="checkbox"
                  id="toSelectedAddonHolders"
                  checked={toSelectedAddonHolders}
                  onChange={this.onCheckboxChange}
                />
                <label htmlFor="toSelectedAddonHolders">Holders of specific add-ons</label>
                <div
                  style={{ display: 'flex', background: '#444447', borderRadius: 4, margin: '0 10px 0 30px' }}
                >
                  {toSelectedAddonHolders &&
                    (addOnsList.length ? (
                      <div className="col-xs-8 col-12 tickets" style={{ padding: 0 }}>
                        {addOnsList}
                      </div>
                    ) : eventAddOnsLoading ? null : (
                      <div className="col-xs-12 col-12">No add-ons found for this event</div>
                    ))}
                </div>
              </div>
            )}
            {hideHoldersOfRefundedTickets ? null : (
              <div className="col-xs-4 col-12 padding-bottom10">
                <input
                  style={{ marginRight: 10 }}
                  type="checkbox"
                  id="toRefundedTicketHolders"
                  checked={values.toRefundedTicketHolders}
                  onChange={this.onCheckboxChange}
                />
                <label htmlFor="toRefundedTicketHolders">Holders of refunded tickets</label>
              </div>
            )}
            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toInfluencers"
                checked={values.toInfluencers}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toInfluencers">All Influencers</label>
            </div>
            <div className="col-xs-4 col-12 padding-bottom10">
              <input
                style={{ marginRight: 10 }}
                type="checkbox"
                id="toTestEmailFlag"
                checked={values.toTestEmailFlag}
                onChange={this.onCheckboxChange}
              />
              <label htmlFor="toTestEmailFlag">Send test</label>
              {values.toTestEmailFlag && (
                <div className="col-xs-12 col-12 padding-bottom10" style={{ float: 'none', marginTop: -16 }}>
                  <Field
                    id="toTestEmail"
                    label=""
                    value={values.toTestEmail}
                    error={errors.toTestEmail}
                    touched={touched.toTestEmail}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
              )}
            </div>
            {isTtfStaff && (
              <div className="col-xs-4 col-12 padding-bottom10">
                <input
                  style={{ marginRight: 10 }}
                  type="checkbox"
                  id="toSpecificEmailHolders"
                  checked={values.toSpecificEmailHolders}
                  onChange={this.onCheckboxChange}
                />
                <label htmlFor="toSpecificEmailHolders">Specific Email Holders</label>
                {values.toSpecificEmailHolders && (
                  <div className="col-xs-12 col-12 padding-bottom10" style={{ float: 'none', marginTop: 10 }}>
                    <div className="eventpromotion-promotion-tag-label">
                      Email Addresses (press space or enter after each one)
                    </div>
                    <TagsField
                      tagsContainerClassName={`form-control${errors.specificEmailAddresses && touched.specificEmailAddresses ? ' form-control-error' : ''
                        }`}
                      value={values.specificEmailAddresses}
                      onChange={this.onSpecificEmailsChange}
                      controlOutside
                      placeholder={'Add an email'}
                      error={errors.specificEmailAddresses}
                      touched={touched.specificEmailAddresses}
                      inputValue={values.specificEmail}
                      onChangeInput={value => {
                        handleChange({ target: { name: 'specificEmail', value } })
                      }}
                      renderTag={props => {
                        const { tag, key, disabled, onRemove, classNameRemove, getTagDisplayValue, ...other } = props
                        const isValid = global.emailRegex && global.emailRegex.test(tag)
                        return (
                          <span
                            key={key}
                            {...other}
                            style={{
                              color: isValid ? 'rgb(233, 233, 233)' : '#d27373',
                              maxWidth: '100%',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              verticalAlign: 'bottom',
                            }}
                          >
                            {getTagDisplayValue(tag)}
                            {!disabled && <a className={classNameRemove} onClick={e => onRemove(key)} />}
                          </span>
                        )
                      }}
                      onlyUnique={true}
                      addKeys={[9, 13, 32, 188]}
                      pasteSplit
                      inputClassName="input-responsive"
                      tagsInputClassName="limit-input"
                    />
                  </div>
                )}
              </div>
            )}
            <div className="col-xs-12 col-12" />
            {isTfUser && (
              <>
                <div className="col-xs-4 col-12" style={{ margin: '4px 8px' }}>
                  <FormikField
                    name="flagBrandDisclaimer"
                    label="Include Brand disclaimer"
                    component={CheckboxField}
                    onChange={(field, value) => handleChange(field, value)}
                    containerProps={{ className: 'checkbox-square base s20' }}
                    mainContainerProps={{ className: 'checkbox-group-square base s20' }}
                  />
                </div>
                <div className="col-xs-12 col-12" />
              </>
            )}
            {toTicketHolders &&
              (eventTickets.length ? (
                <div
                  style={{ marginLeft: '5px' }}
                  className={'col-xs-12 col-12 tickets ' + (values.toSelected ? 'show' : '')}
                >
                  {noGroupedTickets.length ? (
                    <div className="no-grouped-tickets">
                      <MultiCheckbox
                        options={_map(noGroupedTickets, e => ({
                          value: e.id,
                          label: e.displayName,
                        }))}
                        value={this.state.selectedNoGroupedTickets}
                        onChange={e => {
                          this.setState(() => ({ selectedNoGroupedTickets: e }))
                          this.props.setFieldValue('toSelected', e)
                        }}
                      />
                    </div>
                  ) : null}

                  {groupedTickets.length ? (
                    <SelectTimeSlots
                      groupedTickets={groupedTickets}
                      timeSlotTickets={this.getOnlyTimeSlotTickets()}
                      onChange={v => {
                        this.props.setFieldValue('toSelected', v)
                      }}
                    />
                  ) : null}
                </div>
              ) : eventTicketsLoading ? null : (
                <div className="col-xs-12 col-12">No tickets found for this event</div>
              ))}
          </div>
          {(eventAddOnsLoading || eventTicketsLoading) && <LoadingBar />}
          <div className="row">
            <div className="col-xs-12">Body</div>
            <div className="col-xs-12">
              <RichTextArea
                ref={this.editorRef}
                id="body"
                height={600}
                disableEmbeds={true}
                baseurl={ENV.CDN_URL}
                value={values.body}
                error={errors.body}
                touched={touched.body}
                onChange={this.onBodyChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
          <div className="" style={{ display: 'flex' }}>
            <CustomTooltip
              id="event-marketing-disclaimer-tooltip"
              tooltip={
                <span>
                  To send messages to your patrons in general, please use the Messaging function under{' '}
                  <a
                    href={`${window.location.origin}/brand/${event?.owner?.id}/messaging`}
                    style={{ color: '#337ab7', textDecoration: 'none' }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    your Brand
                  </a>
                  .
                </span>
              }
              delayHide={1500}
            >
              <FormikField
                name="marketingDisclaimer"
                label="The above message is not for general marketing or advertising purposes not related to this event."
                component={CheckboxField}
                onChange={(field, value) => handleChange(field, value)}
                containerProps={{ className: 'checkbox-square base s20' }}
                mainContainerProps={{ className: 'checkbox-group-square base s20' }}
              />
            </CustomTooltip>
          </div>
          <div className="row text-center">
            <Button
              className="btn btn-success btn-lg btn-shadow"
              type="button"
              onClick={this.setConfirmingModalState(true)}
              disabled={this.isSendButtonDisabled(addOnsList)}
            >
              {submitLabel || (
                <span>
                  <i className="fa fa-paper-plane" aria-hidden="true" /> Send
                </span>
              )}
            </Button>
            <ScheduleEmail
              isDisabled={this.isSendButtonDisabled(addOnsList)}
              handleSchedule={this.handleScheduleConfirm}
              event={event}
            />
          </div>
        </div>
        <Modal
          className="modal-dialog modal-trans"
          style={modalStyle}
          isOpen={!!emailTemplatesModalOpen}
          contentLabel="Modal"
          onRequestClose={this.setEmailTemplatesModalState(false)}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div>
                <div className="modal-header">
                  <p className="h4 text-compact">Select Email Template</p>
                </div>
                <div className="modal-body">
                  <div className="emailtemplates-table-container">
                    <div className="email-template-containter">
                      <div className="email-tempalate-title clearfix">
                        <span className="template-left-side">Details</span>
                        <span className="template-right-side mobile-template-action">Action</span>
                      </div>
                      <div className="email-template-content">
                        {emailTemplates &&
                          emailTemplates.map((template, index) => (
                            <div key={index} className="clearfix">
                              <div className="template-list">
                                <div className="template-left-side">
                                  <div>
                                    <b className="template-subtitle">Name:</b>
                                    {template.name}
                                  </div>
                                  <div>
                                    <b className="template-subtitle">Subject:</b>
                                    {template.subject}
                                  </div>
                                  <div>
                                    <b className="template-subtitle">Description:</b>
                                    {template.description}
                                  </div>
                                </div>
                                <div className="template-right-side clearfix">
                                  <span
                                    aria-hidden
                                    className="btn btn-primary btn-shadow select-template-btn"
                                    onClick={() => this.selectEmailTemplate(template)}
                                  >
                                    Select
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <div className="btn-toolbar btn-toolbar-right">
                    <Button
                      className="btn btn-success btn-shadow"
                      type="button"
                      onClick={() => replace(`/event/${event.id}/email-templates`)}
                    >
                      Add New Template
                    </Button>
                    <Button
                      className="btn btn-default"
                      type="button"
                      onClick={this.setEmailTemplatesModalState(false)}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          className="modal-dialog modal-trans modal-confirming-emailing"
          style={modalStyle}
          isOpen={isConfirmingModalOpen}
          contentLabel="Modal"
          onRequestClose={this.setConfirmingModalState(false)}
          closeTimeoutMS={150}
          ariaHideApp={false}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">Email Content Review</div>
              <div className="modal-body">
                <h4>Subject: {values.subject}</h4>
                <p className="email-body" dangerouslySetInnerHTML={{ __html: values.body }} />
                {toTicketHolders && (
                  <div className="confirmation-message">
                    Are you sure you want to message the selected ticket holders?
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <div className="btn-toolbar btn-toolbar-right">
                  <Button
                    className="btn btn-success btn-shadow"
                    type="button"
                    disabled={isSubmitting}
                    onClick={this.handleSubmit}
                  >
                    Send Email
                  </Button>
                  <Button
                    className="btn btn-default btn-shadow"
                    type="button"
                    disabled={isSubmitting}
                    onClick={this.setConfirmingModalState(false)}
                  >
                    Cancel &amp; Edit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    )
  }
}

export default withFormik({
  mapPropsToValues: props => ({
    subject: _get(props, 'initialValues.attributes.subject') || '',
    body: _get(props, 'initialValues.attributes.body') || '',
    toBrandSubscribers: _get(props, 'initialValues.attributes.toBrandSubscribers') || false,
    toWaitingList: _get(props, 'initialValues.attributes.toWaitingList') || false,
    toWaitingListWithoutOrders: _get(props, 'initialValues.attributes.toWaitingListWithoutOrders') || false,
    toAll: _get(props, 'initialValues.attributes.toAll') || true,
    toPreregisteredUsers: false,
    toPreregisteredUsersWithoutOrders: false,
    toSelected: _get(props, 'initialValues.attributes.toSelected') || '',
    toSelectedAddonHolders: _get(props, 'initialValues.attributes.toAddOnHolders') || '', // or []
    toFrozenOrders: _get(props, 'initialValues.attributes.toFrozenOrders') || false,
    toRefundedTicketHolders: _get(props, 'initialValues.attributes.toRefundedTicketHolders') || false,
    toAllEventTeamMembers: _get(props, 'initialValues.attributes.toAllEventTeamMembers') || false,
    toInfluencers: _get(props, 'initialValues.attributes.toInfluencers') || false,
    toTestEmailFlag: _get(props, 'initialValues.attributes.toTestEmailFlag') || false,
    toTestEmail: _get(props, 'initialValues.attributes.toTestEmail') || '',
    toSpecificEmailHolders: _get(props, 'initialValues.attributes.toSpecificEmailHolders') || false,
    specificEmail: '',
    specificEmailAddresses: _get(props, 'initialValues.attributes.specificEmailAddresses') || [],
    marketingDisclaimer: false,
    flagBrandDisclaimer: true,
  }),

  // Custom sync validation
  validate: (values, props) => validateForm(values, props),

  handleSubmit: (values, { props, setSubmitting, resetForm, setFieldValue }) => {
    const { marketingDisclaimer, toTestEmailFlag, specificEmail, ...rest } = values

    props
      .onSubmit({
        ...rest,
      })
      .then(v => {
        setSubmitting(false)
        resetForm()
        setFieldValue('subject', 'Message to attendees of ' + props.event.displayName)
      })
      .catch(err => {
        setSubmitting(false)
      })
  },
  displayName: 'EmailToTicketHolders', // helps with React DevTools
})(EmailToTicketHolders)
